import { createReducer, on } from "@ngrx/store";
import { arrayToILoadableWrapperArray, IOrganisation, IOrganisationUser, onLoadableError, onLoadableLoad, onLoadableSuccess, toLoadableWrapper } from "../../common/models";
import { initialAccountState } from "./customer.state";
import { AccountActions } from "./customer.actions";
import { NEW_KEY_ID, removeItem, replaceItem } from "../../common/state/common";


export const accountReducer = createReducer(
    initialAccountState,
    on(AccountActions.loadUsers, (state, { organisation }) => ({
        ...state,
        users: {
            [organisation.id]: {
                ...onLoadableLoad(state.users[organisation.id]),
                items: []
            }
        }
    })),
    on(AccountActions.loadUsersSuccess, (state, { organisation, users }) => ({
        ...state,
        users: {
            ...state.users,
            [organisation.id]: {
                ...onLoadableSuccess(state.users[organisation.id]),
                items: [...arrayToILoadableWrapperArray(users)].sort((a,b) => b.creation_timestamp?.localeCompare(a.creation_timestamp?? "") ?? 0)
            }
        }
    })),
    on(AccountActions.loadUsersError, (state, { organisation, error }) => ({
        ...state,
        users: {
            ...state.users,
            [organisation.id]: {
                ...onLoadableError(state.users[organisation.id], error),
            }
        }
    })),
    on(AccountActions.loadCustomers, state => ({
        ...state,
        organisations: {
            ...onLoadableLoad(state.organisations),
            items: []
        }
    })),
    on(AccountActions.loadCustomersSuccess, (state, { customers }) => ({
        ...state,
        organisations: {
            ...onLoadableSuccess(state.organisations),
            items: arrayToILoadableWrapperArray(customers)
        }
    })),
    on(AccountActions.loadCustomersFailure, (state, { error }) => ({
        ...state,
        organisations: {
            ...onLoadableError(state.organisations, error),
            items: []
        }
    })),
    on(AccountActions.updateCustomerStatus, (state, { organisation, status })  => ({
        ...state,
        organisations: {
            ...state.organisations,
            items: replaceItem(state.organisations.items, onLoadableLoad(toLoadableWrapper({ ...organisation })))
        }
    })),
    on(AccountActions.updateCustomerStatusSuccess, (state, { organisation }) => ({
        ...state,
        organisations: {
            ...state.organisations,
            items: replaceItem(state.organisations.items, onLoadableSuccess(toLoadableWrapper({ ...organisation })))
        }
    })),
    on(AccountActions.updateCustomerStatusError, (state, { organisation, error }) => ({
        ...state,
        organisations: {
            ...state.organisations,
            items: replaceItem(state.organisations.items, onLoadableError(toLoadableWrapper({ ...organisation }), error))
        }
    })),
    on(AccountActions.createUser, (state, { user })  => ({
        ...state,
        users: {
            ...state.users,
            [user.organisation_id!]: {
                ...state.users[user.organisation_id!],
                items: [...state.users[user.organisation_id!].items, onLoadableLoad(toLoadableWrapper({ ...user, id: NEW_KEY_ID } as any))]
            }
        }
    })),
    on(AccountActions.createUserSuccess, (state, { user }) => ({
        ...state,
        users: {
            ...state.users,
            [user.organisation_id]: {
                ...state.users[user.organisation_id],
                items: [...removeItem(state.users[user.organisation_id!].items, NEW_KEY_ID), toLoadableWrapper(user)]
            }
        }
    })),
    on(AccountActions.createUserError, (state, { user, error })  => ({
        ...state,
        users: {
            ...state.users,
            [user.organisation_id!]: {
                ...state.users[user.organisation_id!],
                items: removeItem(state.users[user.organisation_id!].items, NEW_KEY_ID)
            }
        }
    })),
    on(AccountActions.editUser, (state, { user })  => ({
        ...state,
        users: {
            ...state.users,
            [user.organisation_id!]: {
                ...state.users[user.organisation_id!],
                items: replaceItem(state.users[user.organisation_id!].items, onLoadableLoad(toLoadableWrapper({ ...state.users[user.organisation_id!].items.filter(e => e.organisation_id === user.organisation_id!)[0] })))
            }
        }
    })),
    on(AccountActions.editUserSuccess, (state, { user }) => ({
        ...state,
        users: {
            ...state.users,
            [user.organisation_id]: {
                ...state.users[user.organisation_id],
                items: replaceItem(state.users[user.organisation_id!].items, onLoadableSuccess(toLoadableWrapper({ ...user })))
            }
        }
    })),
    on(AccountActions.editUserError, (state, { user, error })  => ({
        ...state,
        users: {
            ...state.users,
            [user.organisation_id!]: {
                ...state.users[user.organisation_id!],
                items: replaceItem(state.users[user.organisation_id!].items, onLoadableError(toLoadableWrapper({ ...state.users[user.organisation_id!].items.filter(e => e.organisation_id === user.organisation_id!)[0] }), error))
            }
        }
    })),

    on(AccountActions.deleteUser, (state, { user })  => ({
        ...state,
        users: {
            ...state.users,
            [user.organisation_id]: {
                ...state.users[user.organisation_id],
                items: replaceItem(state.users[user.organisation_id].items, onLoadableLoad(toLoadableWrapper({ ...user })))
            }
        }
    })),
    on(AccountActions.deleteUserSuccess, (state, { user }) => ({
        ...state,
        users: {
            ...state.users,
            [user.organisation_id]: {
                ...state.users[user.organisation_id],
                items: removeItem(state.users[user.organisation_id].items, user.id)
            }
        }
    })),
    on(AccountActions.deleteUserError, (state, { user, error })  => ({
        ...state,
        users: {
            ...state.users,
            [user.organisation_id]: {
                ...state.users[user.organisation_id],
                items: replaceItem(state.users[user.organisation_id].items, onLoadableError(toLoadableWrapper({ ...user }), error))
            }
        }
    })),

    on(AccountActions.deleteCustomer, (state, { organisation })  => ({
        ...state,
        organisations: {
            ...state.organisations,
            items: replaceItem(state.organisations.items, onLoadableLoad(toLoadableWrapper({ ...organisation })))
        }
    })),
    on(AccountActions.deleteCustomerSuccess, (state, { organisation }) => ({
        ...state,
        organisations: {
            ...state.organisations,
            items: removeItem(state.organisations.items, organisation.id )
        }
    })),
    on(AccountActions.deleteCustomerError, (state, { organisation, error }) => ({
        ...state,
        organisations: {
            ...state.organisations,
            items: replaceItem(state.organisations.items, onLoadableError(toLoadableWrapper({ ...organisation }), error))
        }
    })),
    on(AccountActions.createCustomer, (state, { name, contactNumber, email })  => ({
        ...state,
        organisations: {
            ...state.organisations,
            items: [...state.organisations.items, onLoadableLoad(toLoadableWrapper({ 
                name: name,
                contact_number: contactNumber,
                email_address: email,
                id: NEW_KEY_ID
             } as IOrganisation))]
        }
    })),
    on(AccountActions.createCustomerSuccess, (state, { organisation }) => ({
        ...state,
        organisations: {
            ...state.organisations,
            items: [...removeItem(state.organisations.items, NEW_KEY_ID ), toLoadableWrapper(organisation)]
        }
    })),
    on(AccountActions.createCustomerError, (state, { error }) => ({
        ...state,
        organisations: {
            ...state.organisations,
            items: state.organisations.items.map(e => {
                if (e.id === NEW_KEY_ID) {
                    return onLoadableError({
                        ...e
                    }, error)
                } 
                return e
            })
        }
    })),
    on(AccountActions.updateCustomer, AccountActions.updateOrganisationLogo, (state, { organisationId }) => {
        const existing = state.organisations.items.find(o => o.id === organisationId);
        if (!existing) {
            return state;
        }
        return {
            ...state,
            organisations: {
                ...state.organisations,
                items: replaceItem(state.organisations.items, onLoadableLoad(toLoadableWrapper({ ...existing })))
            }
        };
    }),
    on(AccountActions.updateCustomerSuccess, AccountActions.updateOrganisationLogoSuccess, (state, { organisation }) => ({
        ...state,
        organisations: {
            ...state.organisations,
            items: replaceItem(state.organisations.items, onLoadableSuccess(toLoadableWrapper(organisation)))
        }
    })),
    on(AccountActions.updateCustomerError, AccountActions.updateOrganisationLogoError, (state, { organisationId, error }) => {
        const existing = state.organisations.items.find(o => o.id === organisationId);
        if (!existing) {
            return state;
        }
        return {
            ...state,
            organisations: {
                ...state.organisations,
                items: replaceItem(state.organisations.items, onLoadableError(toLoadableWrapper({ ...existing }), error))
            }
        };
    }),
    on(AccountActions.clearCurrentOrganisation, state => ({
        ...state,
        currentOrganisation: undefined
    })),
    on(AccountActions.setCurrentOrganisation, (state, { organisation }) => ({
        ...state,
        currentOrganisation: organisation.id
    })),
    on(AccountActions.enableScoutType, (state, { organisationId }) => {
        const existing = state.organisations.items.find(o => o.id === organisationId);
        if (!existing) {
            return state;
        }
        return {
            ...state,
            organisations: {
                ...state.organisations,
                items: replaceItem(state.organisations.items, onLoadableLoad(toLoadableWrapper({ ...existing })))
            }
        };
    }),
    on(AccountActions.enableScoutTypeFailure, (state, { organisationId, error }) => {
        const existing = state.organisations.items.find(o => o.id === organisationId);
        if (!existing) {
            return state;
        }
        return {
            ...state,
            organisations: {
                ...state.organisations,
                items: replaceItem(state.organisations.items, onLoadableError(toLoadableWrapper({ ...existing }), error))
            }
        };
    }),
    on(AccountActions.enableScoutTypeSuccess, (state, { organisationId, copilotUser }) => {
        const existing = state.organisations.items.find(o => o.id === organisationId);
        if (!existing) {
            return state;
        }
        const updated: IOrganisation = {
            ...existing,
            copilot_users: [...(existing.copilot_users ?? []), copilotUser]
        };
        return {
            ...state,
            organisations: {
                ...state.organisations,
                items: replaceItem(state.organisations.items, onLoadableSuccess(toLoadableWrapper(updated)))
            }
        };
    }),
    on(AccountActions.disableScoutType, (state, { organisationId }) => {
        const existing = state.organisations.items.find(o => o.id === organisationId);
        if (!existing) {
            return state;
        }
        return {
            ...state,
            organisations: {
                ...state.organisations,
                items: replaceItem(state.organisations.items, onLoadableLoad(toLoadableWrapper({ ...existing })))
            }
        };
    }),
    on(AccountActions.disableScoutTypeFailure, (state, { organisationId, error }) => {
        const existing = state.organisations.items.find(o => o.id === organisationId);
        if (!existing) {
            return state;
        }
        return {
            ...state,
            organisations: {
                ...state.organisations,
                items: replaceItem(state.organisations.items, onLoadableError(toLoadableWrapper({ ...existing }), error))
            }
        };
    }),
    on(AccountActions.disableScoutTypeSuccess, (state, { organisationId, copilotUserId }) => {
        const existing = state.organisations.items.find(o => o.id === organisationId);
        if (!existing) {
            return state;
        }
        const updated: IOrganisation = {
            ...existing,
            copilot_users: (existing.copilot_users ?? []).filter(cu => cu.id !== copilotUserId)
        };
        return {
            ...state,
            organisations: {
                ...state.organisations,
                items: replaceItem(state.organisations.items, onLoadableSuccess(toLoadableWrapper(updated)))
            }
        };
    }),
)